/** Статуси зміни (backend ShiftStatus). Переходи лише вперед: Нова → Розпочата → Завершена */
export type ShiftStatus = 'new' | 'started' | 'completed'

export const SHIFT_STATUS_OPTIONS: Array<{ value: ShiftStatus; label: string; color: string }> = [
    { value: 'new', label: 'Нова', color: '#4a9eff' },
    { value: 'started', label: 'Розпочата', color: '#faad14' },
    { value: 'completed', label: 'Завершена', color: '#52c41a' },
]

export const SHIFT_STATUS_LABELS: Record<ShiftStatus, string> = {
    new: 'Нова',
    started: 'Розпочата',
    completed: 'Завершена',
}
